module.exports = __webpack_public_path__ + "img/ip-mgmt-logo-dark.094d33c5.png";